// Arabic wording belongs to the original Arabic search, not the current UI
// locale. Switching UI language must not translate an English search's tags.
export const matchLabel = check => check.display_language === 'ar' && check.label_ar
  ? check.label_ar : check.label;

// Older agent/connector records store the display label directly. Isolate mixed
// Arabic/Latin text without translating an English search because the UI is RTL.
export const matchDirection = check => check.display_language === 'ar' || /[\u0621-\u064a]/.test(matchLabel(check) || '') ? 'rtl' : undefined;
